const ExamRequestsIndexPage = (resolve) => {
  require.ensure(["./exam-requests/index.vue"], () => {
    resolve(require("./exam-requests/index.vue"))
  }, "procs_exam_requests")
}

const ExamRequestFormPage = (resolve) => {
  require.ensure(["./exam-requests/form.vue"], () => {
    resolve(require("./exam-requests/form.vue"))
  }, "procs_exam_requests")
}

const ShowExamRequestPage = (resolve) => {
  require.ensure(["./exam-requests/show.vue"], () => {
    resolve(require("./exam-requests/show.vue"))
  }, "procs_exam_requests")
}

const CertsIndexPage = (resolve) => {
  require.ensure(["./certs/index.vue"], () => {
    resolve(require("./certs/index.vue"))
  }, "procs_certs")
}

const CertFormPage = (resolve) => {
  require.ensure(["./certs/form/form.vue"], () => {
    resolve(require("./certs/form/form.vue"))
  }, "procs_certs")
}

const ShowCertPage = (resolve) => {
  require.ensure(["./certs/show/show.vue"], () => {
    resolve(require("./certs/show/show.vue"))
  }, "procs_certs")
}

const CertComplementRequestsIndexPage = (resolve) => {
  require.ensure(["./cert-complement-requests/index.vue"], () => {
    resolve(require("./cert-complement-requests/index.vue"))
  }, "procs_cert_complement_requests")
}

const CertFinancialPage = (resolve) => {
  require.ensure(["./certs/financial/financial.vue"], () => {
    resolve(require("./certs/financial/financial.vue"))
  }, "procs_certs")
}

export default (appRoutes) => {  
  appRoutes.push({ path: "procs/exam-requests", component: ExamRequestsIndexPage })
  appRoutes.push({ path: "procs/exam-requests/:id/form", component: ExamRequestFormPage })
  appRoutes.push({ path: "procs/exam-requests/:id/show", component: ShowExamRequestPage })
  appRoutes.push({ path: "procs/certs", component: CertsIndexPage })
  appRoutes.push({ path: "procs/certs/:id/form", component: CertFormPage })
  appRoutes.push({ path: "procs/certs/:id/show", component: ShowCertPage })
  appRoutes.push({ path: "procs/cert-complement-requests", component: CertComplementRequestsIndexPage })
  appRoutes.push({ path: "procs/certs/:id/financial", component: CertFinancialPage })
}